export default {
  'account.inforamtionDetail': 'Information Details',
  'account.name': 'Account Name',
  'account.number': 'Account Number',
  'account.billingCycleType': 'Billing Cycle Type',
  'account.billFlag': 'Bill Flag',
  'account.language': 'Language',
  'account.billingAddress': 'Billing Address',
  'account.billDeliveryMethod': 'Bill Delivery Method',
  'account.sms': 'SMS',
  'account.fax': 'Fax',
  'account.email': 'Email',
  'account.paymentMethod': 'Payment Method',
  'account.billFormat': 'Bill Format',
  'account.remark': 'Remark',
  'account.stateProvince': 'State/Province/Region',
  'account.city': 'City',
  'account.addressline1': 'Address Line1',
  'account.addressline2': 'Address Line2',
  'account.list': 'Account List',
  'account.type': 'Account Type',
  'account.post.paid': 'Postpaid',
  'account.pre.paid': 'Prepaid',
  'account.yes': 'Yes',
  'account.no': 'No',
  'account.add.address': 'Add Address',
  'account.modfiy.address': 'Modfiy Address',
  'account.billAddress': 'Bill Address',
  'account.postAddress': 'Post Address',
  'account.add.success': 'Add Account successful!',
  'account.modfiy.success': 'Modify Account successful!',
  'account.search.placeholder': 'Account Name / Number',
  'account.searchMessage':'Please check the information about the {customName} when system could not get result from this query operation.',
  'account': 'account',
  'account.country': 'Country',
  'account.postcode': 'Postcode',
  'account.state': 'State',
  'account.address': 'Address',
  'account.malaysia': 'Malaysia',
  'account.postcodeValid': 'Please enter a 5-digit number postcode.',
  'account.postcodeResult': 'Postcode does not exist',
  'account.autopayActivationTitle': 'Autopay Activation',
  'account.autopayActivationContent': 'By clicking Sign up, you will set up recurring bill payments for the listed Account and Service Numbers on the left. Experience effortless payments, and rest assured that your payment information is protected and secured.',
  'account.autopayActivation.activated.title': 'Autopay Activated',
  'account.autopayActivation.activated.text': 'Autopay is now active for your convenience. Manage it your way by reviewing your payment information, modifying, or canceling your Autopay service anytime.',
  'account.autopayActivation.activating.title': 'Autopay Request in Progress',
  'account.autopayActivation.activating.text': `We're currently processing your Autopay request. Please come back later for the updated status.`,
  'account.autopayActivation.cardNumber.tooltip': 'Autopay is now active for your convenience.Manage it your way by reviewing your payment information, modifying, or canceling your Autopay service anytime.',
  'account.autopayActivation.modify': 'Modify Autopay',
  'account.autopayActivation.cancel': 'Cancel Autopay',
  'account.autopayActivation.signin.Title': 'Are you sure you want to activate autopay?',
  'account.autopayActivation.signin.Text': 'Customer who subscribed to Unifi product and service (whichever is applicable) is subjected to the Terms & Conditions and Privacy Statement as available at ;',
  'account.autopayActivation.signin.CheckBox': 'Unifi Business:',
  'account.autopayActivation.signin.terms': 'Terms and Conditions',
  'account.autopayActivation.signin.isPayProgress': 'There is a current sign in progress.',
  'account.autopayActivation.signin.isPayComplete': 'Has the sign been completed?',
  'account.autopayActivation.signin.yes': 'Yes',
  'account.autopayActivation.signin.no': 'No',
  'account.autopayActivation.signin.result': 'Sign result waiting',
  'account.autopayActivation.signin.time': 'Count Down',
  'account.autopayActivation.cancel.Text': 'By canceling your Autopay payment, you choose to manually manage your payment schedule. Ready to cancel your Autopay payment?',
  'account.autopayActivation.modify.Text': 'By modifying your Autopay payment, you choose to sign in again. Ready to modify your Autopay payment?',
  'account.autopayActivation.successful': 'Successful!',
  'account.autopayActivation.unsuccessful': 'Unsuccessfully!',
  'account.autopayActivation.signin.successful.text': 'Autopay is now active, ensuring your bills are always on time.',
  'account.autopayActivation.signin.unsuccessful.text': `We're sorry, but we couldn't activate Autopay at this time. Please check your payment details and try again.`,
  'account.autopayActivation.cancel.successful.title': 'Autopay Cancelled',
  'account.autopayActivation.cancel.successful.text': 'Your Autopay payment have been cancelled. Your payments are no longer automatic.',
  'account.autopayActivation.cancel.unsuccessful.text': 'Autopay cancellation encountered an issue. Please verify your settings and try again.',
  'account.autopayActivation.modify.successful.text': 'Autopay details updated! Your changes have been successfully processed for smoother transactions.',
  'account.autopayActivation.modify.unsuccessful.text': `We couldn't process your Autopay details update. Please check your information and try again.`,
};
